import { useSelector, useDispatch } from 'react-redux';
import { selectRadio } from '../EventPane/tabs/radiosSlice';
import RadioChannels from './RadioChannels';
import RadioDetails from './RadioDetails';
import { StyledRadiosPane } from './RadiosPane.styles';

const RadiosPane = () => {
  const dispatch = useDispatch();
  // TODO: Uncomment when ready to fetch, this is so the mock data can kick in
  // const radios = useSelector(state => state.radios.radios);

  const selectedRadio = useSelector(state => state.radios.selectedRadio);
  const isRadioSelected = !!selectedRadio;

  const handleRadioSelection = radio => {
    dispatch(selectRadio(radio));
  };

  return (
    <StyledRadiosPane>
      {isRadioSelected ? (
        <RadioDetails
          radio={selectedRadio}
          onBack={() => dispatch(selectRadio(null))}
        />
      ) : (
        <RadioChannels
          radios={undefined}
          onRadioSelection={handleRadioSelection}
        />
      )}
    </StyledRadiosPane>
  );
};

export default RadiosPane;
